var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("menu.customer_service_ticket_list")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "ticket-list page-container" },
      [
        _c(
          "div",
          { staticClass: "filter-right-container" },
          [
            _c("div", { staticClass: "filter-container-tag" }, [
              _vm._v(" " + _vm._s(_vm.$t("components.activity")) + " "),
            ]),
            _c(
              "el-popover",
              { attrs: { placement: "bottom", trigger: "click" } },
              [
                _c("div", { staticClass: "filter-section-container" }, [
                  _c(
                    "div",
                    {
                      staticClass: "filter-content",
                      attrs: { id: "filter-content" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(_vm._s(_vm.$t("components.create_time"))),
                          ]),
                          _c("el-date-picker", {
                            staticClass: "filter-item-value",
                            attrs: {
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              type: "daterange",
                              "range-separator": "~",
                              "start-placeholder": _vm.$t(
                                "components.start_date"
                              ),
                              "end-placeholder": _vm.$t("components.end_date"),
                            },
                            model: {
                              value: _vm.search.period,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "period", $$v)
                              },
                              expression: "search.period",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(_vm._s(_vm.$t("components.status"))),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item-value",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(
                              _vm.csTicketStatusMap,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("customerService.business_type"))
                            ),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item-value",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.search.operation_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "operation_type", $$v)
                                },
                                expression: "search.operation_type",
                              },
                            },
                            _vm._l(
                              _vm.merchantProductMap,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("customerService.customer_phone_number")
                              )
                            ),
                          ]),
                          _c("el-input", {
                            staticClass: "filter-item-value",
                            attrs: { type: "text", clearable: "" },
                            model: {
                              value: _vm.search.phone_no,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.search,
                                  "phone_no",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "search.phone_no",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "filter-item" },
                        [
                          _c("div", { staticClass: "filter-item-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("customerService.merchant_order_id")
                              )
                            ),
                          ]),
                          _c("el-input", {
                            staticClass: "filter-item-value",
                            attrs: { type: "text", clearable: "" },
                            model: {
                              value: _vm.search.merchant_order_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "merchant_order_id", $$v)
                              },
                              expression: "search.merchant_order_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "filter-item" }),
                    ]
                  ),
                  _c("div", { staticClass: "filter-operate" }, [
                    _c(
                      "div",
                      { staticClass: "filter-operate-right" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "search-btn mb-10",
                            on: { click: _vm.onClickReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("components.clear")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "search-btn mb-10",
                            attrs: { type: "primary", icon: "el-icon-search" },
                            on: { click: _vm.onClickSearchBtn },
                          },
                          [_vm._v(_vm._s(_vm.$t("components.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "mb-10 mr-12",
                    attrs: { slot: "reference", type: "info", plain: "" },
                    slot: "reference",
                  },
                  [
                    _c("svg-icon", {
                      attrs: { "class-name": "mr-10", "icon-class": "filter" },
                    }),
                    _vm._v(_vm._s(_vm.$t("components.filter"))),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticClass: "mb-10 mr-12",
                attrs: {
                  plain: "",
                  loading: _vm.downloading,
                  disabled: _vm.downloading,
                  type: "info",
                },
                on: { click: _vm.onClickDowmloadBtn },
              },
              [
                _c("svg-icon", { attrs: { "icon-class": "download" } }),
                _vm._v(" " + _vm._s(_vm.$t("components.download"))),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticClass: "filter-btn-add mb10 ",
                attrs: { type: "primary" },
                on: { click: _vm.onClickAddBtn },
              },
              [
                _c("i", {
                  staticClass: "el-icon-plus",
                  staticStyle: { "font-weight": "600" },
                }),
                _vm._v(" " + _vm._s(_vm.$t("components.add"))),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "tableContainer" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticClass: "tableContainer",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  stripe: "",
                  fit: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.work_order_number"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.issue_no))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("merchantAccount.merchant_order_id"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.merchant_order_id)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.business_type"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getBusinessTypeLabel(
                                  scope.row.operation_type
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  key: "amount",
                  attrs: {
                    label: _vm.$t("components.amount"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toDivideWithDot")(scope.row.amount)
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.transaction_date"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.transaction_date)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.create_time"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.create_time))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.status"),
                    "min-width": "170",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              staticClass: "tag-custom",
                              staticStyle: { "min-width": "120px" },
                              attrs: {
                                type: _vm.getTicketStatusStyle(
                                  scope.row.status
                                ),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getTicketStatusLabel(scope.row.status)
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.operation"),
                    align: "center",
                    "min-width": "130",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "info", size: "small", plain: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailBtn(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("components.view_details")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                !_vm.listLoading
                  ? _c("paginator", {
                      attrs: { "list-query": _vm.listQuery },
                      on: { "paginator-change": _vm.onClickPaginator },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c("AddTicketModal", {
          ref: "addTicketRef",
          on: { updateList: _vm.getTicketList },
        }),
        _c("TicketDetailsModal", {
          ref: "ticketDetailsModalRef",
          attrs: { "detail-id": _vm.detailId },
        }),
        _c("ReOpenReply", {
          ref: "reOpenReplyModal",
          attrs: { "detail-id": _vm.detailId },
          on: { updateList: _vm.onClickPaginator },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }